import { styled } from '@mui/material/styles';

export const DonutBox = styled('div')(({ theme }) => ({
  '& .donutchart-arcs-path': {
    strokeWidth: '2px',
    opacity: 1
  },
  '& .donutchart-innertext-label': {
    transform: 'translate(0, 17.5%)',
    fontSize: '17px',
    fontWeight: 200,
    opacity: 0.7
  },
  '& .donutchart-innertext-value': {
    transform: 'translate(0, -11%)',
    fontSize: '24px',
    fontWeight: 700,
    fill: 'black !important'
  }
}));
